module.exports = "/wwwroot/img/theme_page.png?ver=b77e90fe";